import { Options, Vue } from 'vue-class-component';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { TrustAPI } from '@/shared/modules/trust-api';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import { Inject } from 'vue-property-decorator';
import { AppInsights } from '@/trust-admin-app/appInsights';

@Options({
  props: {
    selectedEE: Object,
    formType: Number,
    actionType: Number,
  },
  components: {
    ModalBox,
    LoadingIndicator,
  }
})
export default class TrustDataExternalExaminerModal extends Vue {
  private selectedEE!: any;
  private formType!: number;
  private actionType!: number;

  private isSubmitting = false;
  private isLoading = false;
  private isFormDirty = true;
  private reason = '';

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get line1Text() {
    if (this.selectedEE.eeRequestFormStatus.id === 3) {
      return 'View approval details';
    }
    else {
      switch (this.formType) {
        case 1:
          return 'Appointment of External Examiner Request';
        case 2:
          return 'Termination of External Examiner Request';
      }
    }
    return '';
  }

  get questionText() {
    // 1: appoint, 2: terminate
    switch (this.formType) {
      case 1:
        return 'Do you wish to appoint this External Examiner to the Practice stated above?';
      case 2:
        return 'Do you wish to terminate this External Examiner to the Practice stated above?';
    }
    return '';
  }

  get btnText() {
    switch (this.actionType) {
      case 1:
        return 'Approve';
      case 2:
        return 'Reject';
    }
    return '';
  }

  mounted() {
    this.reason = '';
  }

  private closeModal() {
    this.$emit('closeEEModal');
  }

  private submitting() {
    this.isSubmitting = true;
    if (this.reason === '') {
      return;
    } else {
      switch (this.actionType) {
        case 1:
          this.approve();
          break;
        case 2:
          this.reject();
          break;
      }
    }

  }

  private async approve() {
    this.isLoading = true;
    await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminApproveEeRequestFormPost(
      {
        eeRequestFormId: this.selectedEE.id,
        note: this.reason,
      }
    ).then((res) => {
      this.eventCtrl.emit('show-snackbar', 'success', 'Approve Successfully');
      this.$emit('reloadData', res);
      this.closeModal();
    }).catch((err) => {
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to approve');
      this.ai.trackException('Error on approve EE: ' + err);
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private async reject() {
    this.isLoading = true;
    await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminRejectEeRequestFormPost({
      eeRequestFormId: this.selectedEE.id,
      note: this.reason,
    })
      .then((res) => {
        this.eventCtrl.emit('show-snackbar', 'success', 'External Examiner submission Rejected');
        this.$emit('reloadData', res);
        this.closeModal();
      }).catch((err) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to reject');
        this.ai.trackException('Error rejecting EE: ' + err);
      }).finally(() => {
        this.isLoading = false;
      });
  }

}
